import { gql } from './__generated__';

export const USER_ACTIVITY_LOG_TABLE_FRAGMENT = gql(/* GraphQL */ `
  fragment UserActivityLogFragment on UserActivityLog {
    id
    createdAt
    entityType
    type
    additionalData {
      __typename
      ... on UserActivityLogAdditionalDataCompletedTestAttept {
        rwScore
        mathScore
      }
      ... on UserActivityLogAdditionalDataCompletedQuizAttept {
        score
      }
      ... on UserActivityLogAdditionalDataDataUpload {
        uploadId
        fileName
      }
    }
    question {
      id
      originalId
    }
    questionReport {
      id
      question {
        id
        originalId
      }
    }
    test {
      id
      name
      slug
    }
    testAttempt {
      id
      test {
        id
        name
      }
    }
    quiz {
      id
      name
    }
    quizAttempt {
      id
      quiz {
        id
        name
      }
    }
    createdBy {
      id
      email
      name
      schoolName
      graduationYear
      parentEmail
      roles
    }
  }
`);

export const GET_USER_ACTIVITY_LOGS = gql(/* GraphQL */ `
  query getUserActivityLogs(
    $filter: UserActivityLogFilterInput
    $paging: PagingInput
  ) {
    userActivityLog {
      getUserActivityLogs(filter: $filter, paging: $paging) {
        limit
        page
        total
        results {
          ...UserActivityLogFragment
        }
      }
    }
  }
`);

export const CREATE_USER_ACTIVITY_LOG = gql(/* GraphQL */ `
  mutation createExportPdfLog($input: CreateExportPdfLogInput!) {
    userActivityLog {
      createExportPdfLog(input: $input) {
        ...UserActivityLogFragment
      }
    }
  }
`);
